
export interface continueConvState {
  triggerAddActionFlag: boolean;
}

export const initialState: continueConvState = {
  triggerAddActionFlag: false,
};